import React from 'react';
import {Link as GatsbyLink} from 'gatsby';

import {cn} from '../lib/helpers';

import {linkStyle, activeDarkBg, activeLightBg} from './link.module.css';

const Link = ({
  children,
  to = null,
  href = null,
  className,
  bgDark,
  ...rest
}) => {
  if (to !== null) {
    return (
      <GatsbyLink
        to={to}
        className={cn(className, linkStyle)}
        activeClassName={bgDark ? activeDarkBg : activeLightBg}
        partiallyActive={true}
        {...rest}
      >
        {children}
      </GatsbyLink>
    );
  } else {
    return (
      <a href={href} className={cn(className, linkStyle)} {...rest}>
        {children}
      </a>
    );
  }
};

export default Link;
